// extracted by mini-css-extract-plugin
export default {"centered":"expItem_centered__f5W5k","ExpItem":"expItem_ExpItem__AjlvL","expInfo":"expItem_expInfo__2VSiY","details":"expItem_details__dPkg2"};